import { render, staticRenderFns } from "./lealtad-estrateca-canjeos.vue?vue&type=template&id=a120795c&"
import script from "./lealtad-estrateca-canjeos.vue?vue&type=script&lang=js&"
export * from "./lealtad-estrateca-canjeos.vue?vue&type=script&lang=js&"
import style0 from "./lealtad-estrateca-canjeos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports